import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';
import { ProgramaBndesComIndicadorHabilitadoDTO, ProgramaRepasseBndes } from 'src/app/model/programas-permitidos.model';
import { ProgramaBndes } from 'src/app/model/dominio-operacao.model';


@Injectable({
  providedIn: 'root'
})
export class ProgramasPermtidosPorCestasService extends FgiBackEndService<ProgramaRepasseBndes>{

  getNewEntity() {
    return undefined;
  }

  protected getResourceURL(): string {
    return 'front/programa-bndes';
  }

  public buscarProgramasPermitidosPorTranche(ideTranche: number): Observable<Array<ProgramaRepasseBndes>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tranche/${ideTranche}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaRepasseBndes>>;
  }

  public buscarProgramasDisponiveis(ideTranche: number): Observable<Array<ProgramaBndes>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/disponiveis/${ideTranche}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaBndes>>;
  }

  public buscarProgramasPermitidosTrancheAtual(): Observable<Array<ProgramaRepasseBndes>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/permitidos-tranche-atual`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaRepasseBndes>>;
  }

  public buscarTodosComIndicadorHabilitado(ideTranche: number): Observable<Array<ProgramaBndesComIndicadorHabilitadoDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tranche/${ideTranche}/com-uso`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaBndesComIndicadorHabilitadoDTO>>;
  }

  public excluirRepasse(ideTranche: number, idePrograma: number): Observable<Array<ProgramaRepasseBndes>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/tranche/${ideTranche}/programa/${idePrograma}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaRepasseBndes>>;
  }

  public editarRepasse(ideTranche: number, idePrograma: number, dto: any): Observable<void> {
    const options = blockUi();
    return this.http.put(`${this.BASE_URL}/tranche/${ideTranche}/programa/${idePrograma}`, dto, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<void>;
  }

  public habilitar(ideTranche: number, dto: any): Observable<Array<ProgramaRepasseBndes>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/tranche/${ideTranche}`, dto, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaRepasseBndes>>;
  }

  public cadastrar(ideTranche: number, dto: any): Observable<Array<ProgramaRepasseBndes>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/cadastrar`, dto, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<ProgramaRepasseBndes>>;
  }

}
